import React from 'react';

import CTAButton from 'components/CTAButton';
import Tag from 'components/Tag';
import Logo from 'components/Logo';
import Link from 'components/Link';

import { __docsHome } from 'pages/docs/routes';
import {
  __,
  __scheduleDemo,
  xxAppLogin,
} from 'constants/routes';

import styles from './styles.module.scss';

const DocsHeader = () => (
  <header className={styles.outer}>
    <div className={styles.container}>
      <div className={styles['nav-container']}>
        <h1>
          <Link
            to={__.path}
            decoration={false}
            className={styles['logo-link']}
          >
            <Logo />
          </Link>
          <Link
            to={__docsHome.path}
            decoration={false}
            className={styles['docs-link']}
          >
            <Tag accent="blue">
              DOCS
            </Tag>
          </Link>
        </h1>
        <div className={styles.search}>
          {/* TODO: add search functionality here */}
        </div>
        <nav className={styles['cta-nav']}>
          <CTAButton
            arrow={false}
            variant="link"
            text="Request access"
            to={__scheduleDemo.path}
          />
          <CTAButton
            text="Log in"
            to={xxAppLogin.path}
          />
        </nav>
      </div>
    </div>
  </header>
);

export default DocsHeader;
